import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import ProductImage from '@/components/ProductImage'
import { translate } from '@/utils/translations'

import MetaData from './MetaData'

const GTM_TYPE = 'gtm/productClick'
const PDP_RECOMMENDATIONS = 'PDP Recommendations'
const PDP_RECOMMENDED_PRODUCTS = 'Recommended Products PDP'
const PDP_RECOMMENDED_PRODUCTS_ID = 'recommended_products_PDP'
const list = {
  listId: PDP_RECOMMENDED_PRODUCTS_ID,
  listName: PDP_RECOMMENDED_PRODUCTS,
  listType: PDP_RECOMMENDATIONS
}

const RelatedAsset = ({ assetKey }) => {
  const asset = useSelector(state => state.asset.relatedAssets.assets[assetKey])
  const {
    author,
    edition,
    productImageUrl,
    selectedVariant,
    slug,
    title,
    assetKind,
  } = asset

  const assetsOrder = useSelector(
    state => state.asset.relatedAssets.assetsOrder
  )
  const position = assetsOrder.indexOf(assetKey)

  const dispatch = useDispatch()

  const onClickHandler = () => {
    dispatch({
      payload: { asset, list, position, variant: selectedVariant },
      type: GTM_TYPE
    })
  }

  const STYLES_KEY = 'related_products__container__related_product'

  return (
    <li className={`${STYLES_KEY} p-0 mb-4 mb-md-0 d-flex
      flex-column align-items-start`}
    >
      <div className={`${STYLES_KEY}__cover`}>
        <ProductImage
          ariaHideAnchor
          className='w-100 h-100'
          divClassName={`${STYLES_KEY}__cover_image`}
          onClickHandler={onClickHandler}
          productTitle={title}
          productUrl={slug}
          url={productImageUrl}
          width={200}
        />
      </div>
      <div className='pill-outline-secondary-branded mb-2 mt-2'>
        {assetKind}
      </div>
      <div className={`${STYLES_KEY}__title text-left`}>
        <a
          className="u-weight--bold"
          href={slug}
          onClick={onClickHandler}
        >
          {title}
        </a>
      </div>
      <MetaData content={edition}>
        <div className={`${STYLES_KEY}__edition`}>
          {`${edition} ${translate('common.edition')}`}
        </div>
      </MetaData>
      <MetaData content={author}>
        <div className={`${STYLES_KEY}__author`}>
          {author}
        </div>
      </MetaData>
    </li>
  )
}

RelatedAsset.propTypes = {
  assetKey: PropTypes.number.isRequired
}

export default RelatedAsset
